/** A date picker shows UK calendar dates; untouched timed offers retain their exact end time. */
export function offerExpiryFormDate(value: string | null | undefined): string {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
  const part = (key: string) => parts.find(p => p.type === key)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}
export function offerExpiryFormValue(original: string | null | undefined, selected: string, changed: boolean, editing: boolean): string | null {
  return editing && !changed ? original ?? null : selected || null;
}
